import { useEffect, useState } from "react";
import infoIcon from "../../../icons/webicons/AlertInfo-blue.svg";
import greenCheckIcon from "../../../icons/webicons/green-check.svg";
import {
  ToastWrapper,
  IconWrapper,
  ToastIcon,
  ContentWrapper,
  ToastTitle,
  ToastMessage,
} from "./styles";

const Toast = ({ inProgress, success }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!inProgress && !success) {
      setIsVisible(false);
      return;
    }
    setIsVisible(true);
    const timer = setTimeout(() => setIsVisible(false), 5000);
    return () => clearTimeout(timer);
  }, [inProgress, success]);

  if (!isVisible) return null;

  const isSuccess = success && !inProgress;

  return (
    <ToastWrapper isSuccess={isSuccess}>
      <IconWrapper>
        <ToastIcon
          src={isSuccess ? greenCheckIcon : infoIcon}
          alt=""
        />
      </IconWrapper>

      <ContentWrapper>
        <ToastTitle isSuccess={isSuccess}>
          {isSuccess ? "PDF extraction successful" : "PDF extraction started"}
        </ToastTitle>
        <ToastMessage>
          Processing in background. You'll be notified when complete.
        </ToastMessage>
      </ContentWrapper>
    </ToastWrapper>
  );
};

export default Toast;
